import { useState, useEffect } from "react";
// import { filteredEventsAtom } from "../store/events";
// import { useAtomValue } from "jotai";
//import EventCard from "../components/event-card";
// import { EventCard } from "../components/event-card/index";
import { Loading } from "../components/loader";
// import { EventFilter } from "../components/event-filter";
// import Banners from "../components/banners";
// import CommonFrame from "../components/layouts/common-frame";

export default function Home() {
  // const filteredEvents = useAtomValue(filteredEventsAtom);

  // Only show loader if not already shown in this session
  const [showLoader, setShowLoader] = useState(() => {
    return (
      typeof window !== "undefined" &&
      sessionStorage.getItem("mash_home_loader_shown") !== "true"
    );
  });

  useEffect(() => {
    if (!showLoader) return;
    const timer = setTimeout(() => {
      setShowLoader(false);
      sessionStorage.setItem("mash_home_loader_shown", "true");
    }, 1500);
    return () => clearTimeout(timer);
  }, [showLoader]);

  if (showLoader) {
    return (
      <div className="w-full h-dvh flex items-center justify-center bg-background dark:bg-mash-black">
        <Loading />
      </div>
    );
  }

  return (
    <div className="flex justify-between mt-24 m-2 gap-2">
      <div className="max-w-4xl mx-auto pt-8">
        <div className="border border-mash-gray dark:border-mash-gray bg-mash-dark rounded-2xl p-6 sm:p-8 mb-8">
          <div className="flex flex-col">
            <h1 className="text-2xl sm:text-3xl font-bold text-mash-gray-700 dark:text-mash-gray-300 mb-3">
              MASH IS DEAD. LONG LIVE MASH!
            </h1>
            <p className="text-mash-gray-600 dark:text-mash-gray-400 max-w-2xl mb-6 font-bold">
              Mash pioneered Sports Perps - scalar prediction markets with
              leverage, built for sports.
            </p>
            <p className="text-mash-gray-600 dark:text-mash-gray-400 max-w-2xl mb-6">
              Since launching in September 2025, Mash proved that traders want a
              new way to speculate on sports - continuous, leveraged positions
              that brought the UX of perps to the drama of sports outcomes. The
              response from early users blew us away.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-4 w-full">
              <div className="bg-white/50 dark:bg-black/30 rounded-xl p-4 border border-mash-gray-100 dark:border-mash-gray-800/50 items-center text-center">
                <div className="text-xs sm:text-sm text-mash-gray-500 dark:text-mash-gray-400 mb-1">
                  Traders
                </div>
                <div className="text-lg sm:text-xl font-bold text-mash-gray-700 dark:text-mash-gray-300">
                  500+
                </div>
              </div>
              <div className="bg-white/50 dark:bg-black/30 rounded-xl p-4 border border-mash-gray-100 dark:border-mash-gray-800/50 items-center text-center">
                <div className="text-xs sm:text-sm text-mash-gray-500 dark:text-mash-gray-400 mb-1">
                  Total Volume
                </div>
                <div className="text-lg sm:text-xl font-bold text-mash-gray-700 dark:text-mash-gray-300">
                  $2.5M
                </div>
              </div>
              <div className="bg-white/50 dark:bg-black/30 rounded-xl p-4 border border-mash-gray-100 dark:border-mash-gray-800/50  items-center text-center">
                <div className="text-xs sm:text-sm text-mash-gray-500 dark:text-mash-gray-400 mb-1">
                  Vault Liquidity
                </div>
                <div className="text-lg sm:text-xl font-bold text-mash-gray-700 dark:text-mash-gray-300">
                  $100k
                </div>
              </div>
            </div>
            <p className="text-mash-gray-600 dark:text-mash-gray-400 max-w-2xl mb-6 mt-6">
              The Mash team is now building the next iteration - an
              enterprise-scale platform capable of running hundreds of exotic
              sports perps markets, with the infrastructure to support
              institutional-grade liquidity and scale.
            </p>
            <p className="text-mash-gray-600 dark:text-mash-gray-400 max-w-2xl mb-6">
              We&apos;ve made the difficult decision to sunset this version of
              Mash so the team can go all-in on what comes next. User funds and
              Vault deposits should be withdrawn.
            </p>
            <p className="text-mash-gray-600 dark:text-mash-gray-400 max-w-2xl mb-6 font-bold">
              To everyone who traded, provided liquidity, gave feedback, and
              believed in the vision early - thank you. We can&apos;t wait to
              share what we&apos;re building.
            </p>
            <p className="text-mash-gray-600 dark:text-mash-gray-400 max-w-2xl mb-6">
              Keep on Mashing ⚡
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
